<!--
/*
 * This file is part of OrangeHRM Inc
 *
 * Copyright (C) 2020 onwards OrangeHRM Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <path
    class="st0"
    d="M 250 0 C 387.99 0 499.999 112.01 499.999 250 C 499.999 387.99 387.99 500 250 500 C 112.009 500 0 387.99 0 250 C 0 112.01 112.009 0 250 0 Z M 399.754 174.755 C 396.16 161.275 385.539 150.735 372.14 147.141 C 347.794 140.605 250.081 140.605 250.081 140.605 C 250.081 140.605 152.369 140.605 128.022 147.141 C 114.542 150.735 104.003 161.356 100.408 174.755 C 93.872 199.101 93.872 250 93.872 250 C 93.872 250 93.872 300.817 100.408 325.245 C 104.003 338.725 114.624 349.265 128.022 352.859 C 152.369 359.395 250.081 359.395 250.081 359.395 C 250.081 359.395 347.794 359.395 372.14 352.859 C 385.62 349.265 396.16 338.644 399.754 325.245 C 406.29 300.899 406.29 250 406.29 250 C 406.29 250 406.29 199.183 399.754 174.755 Z M 218.709 296.895 L 218.709 203.105 L 299.918 250 L 218.709 296.895 Z"
  />
</template>
